// Handlers for user data related actions

import type {
  AddLinksAction,
  ChangeUsernameAction,
  PassUserOnboardingAction,
  SetMarbleUserAction,
  UpdatedMarbleUserAction,
  UpdatedMarbleUserAuthsAction,
  UserDataLoadedAction,
  UserState,
} from './types';
import { initialState } from './initialState';

export const setMarbleUserHandler = (
  _state: UserState,
  { payload }: SetMarbleUserAction,
): UserState => ({
  ...(payload as UserState),
  shareableSettings: payload.shareableSettings
    ? payload.shareableSettings
    : initialState.shareableSettings,
});

export const updatedMarbleUserAuthsHandler = (
  state: UserState,
  { payload }: UpdatedMarbleUserAuthsAction,
): UserState => ({
  ...state,
  ...payload,
});

export const userDataLoadedHandler = (
  state: UserState,
  { payload }: UserDataLoadedAction,
): UserState => ({
  ...state,
  ...payload.me,
});

export const updatedMarbleUserHandler = (
  state: UserState,
  { payload }: UpdatedMarbleUserAction,
): UserState => ({ ...state, ...payload });

export const addLinksHandler = (
  state: UserState,
  { payload }: AddLinksAction,
): UserState => ({
  ...state,
  links: [...(state?.links || []), ...(payload?.links || [])],
});

export const changeUsernameHandler = (
  state: UserState,
  { payload }: ChangeUsernameAction,
): UserState => ({
  ...state,
  username: payload.username,
  shareableSettings: {
    ...state.shareableSettings,
    username: payload.username,
  },
});

export const passUserOnboardingHandler = (
  state: UserState,
  { payload }: PassUserOnboardingAction,
): UserState => ({
  ...state,
  onboardingPassed: payload,
});

export const userLogoutHandler = (): UserState => initialState;
